import React from "react";
import { Link, useParams } from "react-router-dom";
import Details from "../components/details/Details";
import RelatedPosts from "../components/relatedPosts/RelatedPosts";

function PostDetails() {
  const { postID } = useParams();
  return (
    <>
      <div className="container mt-8">
        <Link
          to="/"
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
      </div>
      <section className="post-page-container">
        <Details id={postID} />
        {/* <!-- related posts --> */}
        <RelatedPosts />
        {/* <!-- related posts ends --> */}
      </section>
    </>
  );
}

export default PostDetails;
